import React, { useRef, useState, useMemo, useEffect } from 'react';
import { EditTable } from '@components';
// import { SpiderGridColumns } from '@model/sectionWidget.model';
import { EDIT_TABLE_COLUMNS_TYPE } from '@utils/enums';
import D_Number from '@utils/number';
import { Input, Form, Switch } from 'antd';
import { getSpiderTagsAndRows } from '@components/sectionchart/util';
import { useSelector } from 'react-redux';

export default function SpiderGrid({
  editTableRef,
  isEditMode,
  sourceData,
  handleSave,
  toggleEdit,
}) {
  // false: actual value mode
  // true: label mode
  const [labelMode, setLabelMode] = useState(false);
  const handleSaveSpiderData = (payloadArray = []) => {
    let extraInfo = {};
    if (editTableRef?.current?.getFieldsValue) {
      const { tagA, tagB, tagC, tagD } = editTableRef.current.getFieldsValue();
      extraInfo = { tagA, tagB, tagC, tagD, customizeTags: true };
    }
    handleSave([
      extraInfo,
      ...payloadArray.map((e) =>
        Object.assign(e, { a: parseFloat(e.a), b: parseFloat(e.b) }),
      ),
    ]);
  };

  const { buyerName, targetName } = useSelector(
    ({ common }) => common.projectCompanyInfo,
  );

  const { tagA, tagB, tagC, tagD, dataRows } = getSpiderTagsAndRows(
    sourceData,
    buyerName,
    targetName,
  );
  const tableDataRef = useRef(dataRows);
  const SpiderGridColumns = [
    {
      // title: 'Category',
      title: isEditMode
        ? (props) => (
            <Form.Item {...props} name="tagC" initialValue={tagC}>
              <Input {...props} maxLength={20} />
            </Form.Item>
          )
        : tagC,
      dataIndex: 'c',
      editable: true,
      type: EDIT_TABLE_COLUMNS_TYPE.INPUT,
      compProps: {
        rules: [
          {
            required: true,
            message: `This cell is required.`,
          },
        ],
      },
    },
    {
      title: isEditMode
        ? (props) => (
            <Form.Item {...props} name="tagA" initialValue={tagA}>
              <Input {...props} maxLength={20} />
            </Form.Item>
          )
        : tagA,
      dataIndex: labelMode ? 'aLabel' : 'a',
      editable: true,
      type: EDIT_TABLE_COLUMNS_TYPE.INPUT,
      compProps: labelMode
        ? {
            placeholder: (record) => record.a || 0,
          }
        : {
            defaultValue: 0,
            rules: [
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (value === undefined || value === null || value === '') {
                    return Promise.resolve();
                  }

                  // 检查 value 是否为有效数字
                  if (!/^\d+(\.\d+)?$/.test(value)) {
                    return Promise.reject(
                      new Error('Please enter a valid positive number'),
                    );
                  }
                  const parsedValue = Number(value);

                  if (parsedValue > 0) {
                    return Promise.resolve();
                  }

                  return Promise.reject(
                    new Error('Please enter a valid positive number'),
                  );
                },
              }),
            ],
          },
      width: isEditMode ? undefined : 180,
      render: (text) => (labelMode ? text : D_Number.addSeparator(text)),
    },
    {
      title: isEditMode
        ? (props) => (
            <Form.Item {...props} name="tagB" initialValue={tagB}>
              <Input {...props} maxLength={20} />
            </Form.Item>
          )
        : tagB,
      dataIndex: labelMode ? 'bLabel' : 'b',
      editable: true,
      type: EDIT_TABLE_COLUMNS_TYPE.INPUT,
      width: isEditMode ? undefined : 180,
      compProps: labelMode
        ? {
            placeholder: (record) => record.b || 0,
          }
        : {
            defaultValue: 0,
            rules: [
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (value === undefined || value === null || value === '') {
                    return Promise.resolve();
                  }

                  // 检查 value 是否为有效数字
                  if (!/^\d+(\.\d+)?$/.test(value)) {
                    return Promise.reject(
                      new Error('Please enter a valid positive number'),
                    );
                  }
                  const parsedValue = Number(value);

                  if (parsedValue > 0) {
                    return Promise.resolve();
                  }

                  return Promise.reject(
                    new Error('Please enter a valid positive number'),
                  );
                },
              }),
            ],
          },
      render: (text) => (labelMode ? text : D_Number.addSeparator(text)),
    },
    {
      // title: 'Description',
      title: isEditMode
        ? (props) => (
            <Form.Item {...props} name="tagD" initialValue={tagD}>
              <Input {...props} maxLength={20} />
            </Form.Item>
          )
        : tagD,
      dataIndex: 'd',
      editable: true,
      type: EDIT_TABLE_COLUMNS_TYPE.INPUT,
      flex: 1,
      width: isEditMode ? undefined : 480,
      compProps: {
        type: 'text',
        rules: [
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (value?.length > 500) {
                return Promise.reject('Character limit is 500.');
              }
              return Promise.resolve();
            },
          }),
        ],
      },
    },
  ];

  const onChangeMode = async (checked) => {
    try {
      await editTableRef.current.validateFields();
      setLabelMode(checked);
    } catch (err) {
      console.log('err: ', err);
    }
  };

  useEffect(() => {
    setLabelMode(!isEditMode);
  }, [isEditMode]);
  const editTableParams = useMemo(
    () => ({
      tableProps: {
        pagination: false,
        rowKey: 'id',
      },
      tableColumns: SpiderGridColumns,
      extraBtns: (
        <div className="switch-wrapper">
          Actual Value <Switch checked={labelMode} onChange={onChangeMode} />{' '}
          Label
        </div>
      ),
      // defaultDataSource: dataRows,
      defaultDataSource: tableDataRef.current,
      saveData: handleSaveSpiderData,
      dataChange: (newData) => {
        tableDataRef.current = newData;
      },
      afterCancel: () => {
        tableDataRef.current = dataRows;
      },
      toggleEdit,
    }),
    [sourceData, isEditMode, labelMode],
  );

  return (
    <div className="spider-grid-wrapper">
      <EditTable ref={editTableRef} {...editTableParams} />
    </div>
  );
}
